import * as Actions from '../../actions';

const initialState = { data: null };

const listHaulingReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_HAULING_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listHaulingReducer;
